import * as PIXI from 'pixi.js-legacy';
import Measurements from './Measurements';

export default class MeasurementLayer extends PIXI.Application {
  constructor({
    autoStart,
    autoResize,
    resolution,
    transparent,
    view,
    height,
    width,
    isMobile,
    scene,
  }) {
    super({
      autoStart,
      autoResize,
      resolution,
      transparent,
      view,
      height,
      width,
    });
    PIXI.settings.ROUND_PIXELS = true;
    // capping SPRITE_MAX_TEXTURES fixes a webgl crash in firefox on linux
    PIXI.settings.SPRITE_MAX_TEXTURES = Math.min(
      PIXI.settings.SPRITE_MAX_TEXTURES,
      16
    );
    PIXI.settings.FAIL_IF_MAJOR_PERFORMANCE_CAVEAT = false;

    this.measurements = new Measurements({
      isMobile,
      app: this,
      scene,
    });

    this.stage.addChild(this.measurements);
  }

  setX(x) {
    this.measurements.x = x;
  }

  setY(y) {
    this.measurements.y = y;
  }

  update({
    origo,
    active,
    wallResizerActive,
    tac,
    room,
    ratio,
    isMobile,
    isPortrait,
  }) {
    this.measurements.update({
      origo,
      active,
      wallResizerActive,
      tac,
      room,
      ratio,
      isMobile,
      isPortrait,
    });
    this.render();
  }
}
